import React, { createContext, useContext, useState, useCallback } from 'react';
import CelebrationOverlay from '../components/CelebrationOverlay';

const STORAGE_KEY = 'saydo_celebration_level';

const CelebrationContext = createContext({ level: 2, setLevel: () => {}, celebrate: () => {} });

export const useCelebration = () => useContext(CelebrationContext);

export const CELEBRATION_LEVELS = [
  { value: 0, label: 'None', emoji: '\uD83D\uDD07', description: 'No celebrations' },
  { value: 1, label: 'Subtle', emoji: '\u2728', description: 'Quick, small animations' },
  { value: 2, label: 'Medium', emoji: '\uD83C\uDF89', description: 'Balanced celebrations' },
  { value: 3, label: 'Maximum', emoji: '\uD83C\uDF86', description: 'Full confetti & fanfare' },
];

export const CelebrationProvider = ({ children }) => {
  const [level, setLevelState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved !== null) {
        const parsed = parseInt(saved, 10);
        if (parsed >= 0 && parsed <= 3) return parsed;
      }
    } catch {}
    return 2;
  });

  const [activeCelebration, setActiveCelebration] = useState(null);

  const setLevel = useCallback((newLevel) => {
    const clamped = Math.min(3, Math.max(0, newLevel));
    setLevelState(clamped);
    try { localStorage.setItem(STORAGE_KEY, String(clamped)); } catch {}
  }, []);

  const celebrate = useCallback((data = {}) => {
    if (level === 0) return;
    setActiveCelebration({ ...data, _id: Date.now() });
  }, [level]);

  const dismissCelebration = useCallback(() => {
    setActiveCelebration(null);
  }, []);

  return (
    <CelebrationContext.Provider value={{ level, setLevel, celebrate, activeCelebration, dismissCelebration }}>
      {children}
      <CelebrationOverlay
        celebration={activeCelebration}
        level={level}
        onDismiss={dismissCelebration}
      />
    </CelebrationContext.Provider>
  );
};
